import { AutocompleteCloseReason } from '@mui/material';
import { SyntheticEvent } from 'react';

// Whether picking an option should leave the dropdown open, so the next option
// can be picked without reopening it. True only for a pick made with shift
// held; every other way of closing the dropdown is left alone.
export const shiftKeepsDropdownOpen = (
    event: SyntheticEvent,
    reason: AutocompleteCloseReason,
): boolean => {
    if (reason !== 'selectOption') {
        return false;
    }

    // The pick arrives as a click on the option or as Enter on the highlighted
    // one; anything else carries no modifier state.
    const { nativeEvent } = event;
    if (nativeEvent instanceof MouseEvent || nativeEvent instanceof KeyboardEvent) {
        return nativeEvent.shiftKey;
    }
    return false;
};
